import Component from '@glimmer/component';
interface Signature {
  Element: HTMLTableRowElement;
  Args: {
    name: string;
    isH2: boolean;
  };
}
// eslint-disable-next-line ember/no-empty-glimmer-component-classes
class MyComponent extends Component<Signature> {
  <template>
    <tr class='{{if @isH2 "group-title"}}' ...attributes>
      <td
        class='!bg-white !px-[11px] !py-[15px] ![border-left-style:none] ![border-right-style:none] first:sticky first:left-0 [tr.group-title+tr>&]:![border-top-style:none]'
      >
        {{#if @isH2}}
          <div class='ui divider hidden'></div>
          <h2 class='ui header'>
            {{@name}}
          </h2>
        {{else}}
          <h3 class='ui header'>
            {{@name}}
          </h3>
        {{/if}}
      </td>

      {{! Fake cell to have the top line displayed  }}
      <td
        colspan='100%'
        class='!bg-white !px-[11px] !py-[15px] ![border-left-style:none] ![border-right-style:none] first:sticky first:left-0 [tr.group-title+tr>&]:![border-top-style:none]'
      ></td>
    </tr>
  </template>
}
export default MyComponent;
